import React, { useEffect } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    IconDefinition,
    faMagnifyingGlass,
    faWarning
} from '@fortawesome/free-solid-svg-icons'

//STYLES
import { InputDateWrapper } from './styled'

//APP
import { Render } from '../render'
import { removerEspacos } from '../../../utils'
import { DatePicker } from 'antd'
import dayjs from 'dayjs'

//PROPS
interface Props {
    label?: string;
    value?: any | null;
    onChange: (value: any | null, dateString: string) => void;
    onFocus?: Function;
    onBlur?: Function;
    icon?: IconDefinition
    obrigatorio?: boolean
    opcional?: boolean
    error?: boolean
    errorMessage?: string
    desabilitado?: boolean
    width?: number | string
    maxLength?: number
    height?: number | string
    autoFocus?: boolean
    allowCopy?: boolean
    readOnly?: boolean
    type?: 'text' | 'email' | 'password'
    textTransform?: 'uppercase' | 'lowercase' | 'capitalize'
    allowClear?: false
    refProp?: React.Ref<HTMLInputElement>;
    style?: React.CSSProperties;
    maxDate?: string;
    minDate?: string;
}

const DatePickerCustom: React.FC<Props> = ({ label, value, onChange, icon, obrigatorio, opcional, onFocus,
    error, errorMessage, desabilitado, width, autoFocus, onBlur, style, minDate, maxDate
}) => {

    let temp_id = String(Date.now())

    useEffect(() => {
        if (autoFocus) {
            let input_element = document.getElementById(removerEspacos(temp_id))
            input_element?.focus()
        }
    }, []);

    const disabledDate = (current) => {
        const maxDateAllowed = dayjs(maxDate);
        const minDateAllowed = dayjs(minDate)

        if (minDate && maxDate) {
            return current && (current.isBefore(minDateAllowed, 'day') || current.isAfter(maxDateAllowed, 'day'));
        }
        if (!minDate && maxDate) {
            return current && current.isAfter(maxDateAllowed, 'day');
        }
        if (minDate && !maxDate) {
            return current && current.isBefore(minDateAllowed, 'day')
        }

        return undefined
    };

    return (
        <InputDateWrapper style={{ width: width, ...style }} data-label={!!label}>
            {!!label && (
                <label htmlFor={removerEspacos(temp_id)}>
                    {label}{' '}
                    {obrigatorio ? <span className='InputDateWrapper__obrigatorio'>(obrigatório)</span> : null}{' '}
                    {opcional ? <span className='InputDateWrapper__obrigatorio'>(opcional)</span> : null}{' '}
                </label>
            )}

            <div className='InputDateWrapper__campo' data-error={error} data-disabled={desabilitado}>
                <FontAwesomeIcon
                    icon={(error ? faWarning : icon) ?? faMagnifyingGlass}
                    className='InputDateWrapper__campo__icon'
                />

                <DatePicker
                    suffixIcon={false}
                    bordered={false}
                    placeholder='__/__/____'
                    allowClear={false}
                    format='DD/MM/YYYY'
                    value={value}
                    onChange={onChange as any}
                    style={{ width: 120, gap: 0 }}
                    onFocus={() => onFocus?.()}
                    onBlur={() => onBlur?.()}
                    disabledDate={disabledDate}
                    disabled={desabilitado}
                />

            </div>
            {error && <span className='InputDateWrapper__error'>{errorMessage}</span>}
        </InputDateWrapper>
    )
}

export default DatePickerCustom;
